import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number;
  subdomain: string;
};

const [useUpdateSpaceSubdomain, updateSpaceSubdomain] = createAsyncAction(
  "spaces/updateSpaceSubdomain",
  async ({ spaceId, subdomain }: Args) => {
    const res = await API.call<{ space: number }>({
      endpoint: `spaces/${spaceId}`,
      method: "PUT",
      data: { subdomain },
    });
    return { ...res, result: res.result.space };
  }
);

export default useUpdateSpaceSubdomain;
export { updateSpaceSubdomain };
